export type AdditionalMemberRef = {
  member_id?: number | null;
  id?: number | null;
};

export const getMemberId = (member: AdditionalMemberRef) =>
  member.member_id ?? member.id ?? null;

export type MemberPassportPayload = {
  files: File[];
  indices: number[];
  /** True when any existing member uploads a new passport (edit / mixed scenarios). */
  needsIndices: boolean;
};

/**
 * Builds member_passports files and optional member_passport_indices for create-incorporation.
 *
 * Index `i` in member_passport_indices maps files[i] to additional_members[i] (0-based).
 *
 * | Scenario | member_passports | member_passport_indices |
 * |----------|------------------|-------------------------|
 * | Create / new members only on edit | files | omit |
 * | Existing member passport change | files | required (all files) |
 * | Mixed new + existing passport updates | files | required (all files) |
 */
export const buildMemberPassportPayload = (
  additionalMembers: AdditionalMemberRef[],
  passports: (File | string | null)[],
): MemberPassportPayload => {
  const files: File[] = [];
  const indices: number[] = [];

  additionalMembers.forEach((member, index) => {
    const passport = passports[index];
    if (passport instanceof File) {
      files.push(passport);
      indices.push(index);
    }
  });

  const needsIndices = additionalMembers.some(
    (member, index) =>
      Boolean(getMemberId(member)) && passports[index] instanceof File,
  );

  return { files, indices, needsIndices };
};
